<template>
    <div>
        <div class="container sm:px-10">
            <div class="block xl:grid grid-cols-2 gap-4">
                <!-- BEGIN: Login Info -->
                <div class="hidden xl:flex flex-col min-h-screen">
                    <a href="" class="-intro-x flex items-center pt-5">

                        <span class="text-white text-lg ml-3">
              Five Stars Tours
            </span>
                    </a>
                    <div class="my-auto">
                        <img
                            alt="Icewall Tailwind HTML Admin Template"
                            class="-intro-x w-1/2 -mt-16"
                            :src="asset(images.illustration)"
                        />
                        <div
                            class="-intro-x text-white font-medium text-4xl leading-tight mt-10"
                        >
                            A few more clicks to <br/>
                            sign in to your account.
                        </div>
                    </div>
                </div>
                <!-- END: Login Info -->
                <!-- BEGIN: Login Form -->
                <div class="h-screen xl:h-auto flex py-5 xl:py-0 my-10 xl:my-0">
                    <div
                        class="my-auto mx-auto xl:ml-20 bg-white dark:bg-dark-1 xl:bg-transparent px-5 sm:px-8 py-8 xl:p-0 rounded-md shadow-md xl:shadow-none w-full sm:w-3/4 lg:w-2/4 xl:w-auto"
                    >
                        <h2
                            class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left"
                        >
                            Sign In
                        </h2>
                        <div class="intro-x mt-2 text-gray-500 xl:hidden text-center">
                            A few more clicks to sign in to your account.
                        </div>
                        <form action="#" @submit.prevent="login">
                            <div class="intro-x mt-8">
                                <hint-input v-model="form.username" hint="Username"
                                            :is-invalid="isFieldInvalid('username')"></hint-input>
                                <hint-input v-model="form.password" hint="Password" type="password"
                                            :extra-class="['mt-4']"
                                            :is-invalid="isFieldInvalid('password')"></hint-input>
                            </div>
                            <div
                                class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4"
                            >
                                <div class="flex items-center mr-auto">
                                    <input
                                        id="remember-me"
                                        type="checkbox"
                                        class="form-check-input border mr-2"
                                    />
                                    <label class="cursor-pointer select-none" for="remember-me"
                                    >Remember me</label
                                    >
                                </div>
                            </div>
                            <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
                                <input
                                    type="submit"
                                    value="Login"
                                    class="btn btn-primary py-3 px-4 w-full xl:w-32 xl:mr-3 align-top"
                                >
                            </div>
                        </form>
                    </div>
                </div>
                <!-- END: Login Form -->
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, onMounted} from 'vue'
import cash from "cash-dom/dist/cash";
import Swal from "sweetalert2";
import useVuelidate from '@vuelidate/core'
import {required} from '@vuelidate/validators'
import HintInput from "../global-components/HintInput";
import {asset} from "@codinglabs/laravel-asset";

export default defineComponent({
    components: {HintInput},
    mixins: [{
        methods: {
            asset: asset,
            castTimestamps(obj) {
                // let date = new Date(obj.created_at);
                // obj.created_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;
                //
                // date = new Date(obj.updated_at);
                // obj.updated_at = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.toLocaleTimeString()}`;
            }
        }
    }],
    data() {
        return {
            images: {
                logo: `/images/logo.svg`,
                illustration: `/images/illustration.svg`
            },
            form: {
                username: null,
                password: null
            }
        }
    },
    validations() {
        return {
            form: {
                username: {
                    required
                },
                password: {
                    required
                }
            }
        }
    },
    methods: {
        isFieldInvalid(fieldName) {
            return this.v$.form[fieldName].$dirty && this.v$.form[fieldName].$invalid;
        },
        login: function () {
            this.v$.$touch();
            if (this.v$.$invalid) {
                console.log('Invalid')
                this.$forceUpdate();
                return;
            }
            Swal.fire({
                title: 'Loading',
                timerProgressBar: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });
            axios.default.post('/api/login', {
                username: this.form.username,
                password: this.form.password
            })
                .then(response => {
                    console.log(response.data);
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        showConfirmButton: false,
                        timer: 1500
                    }).then(result => {
                        window.location.replace("/");
                    });
                })
                .catch(error => {
                    console.error(error);
                    Swal.fire({
                        icon: 'error',
                        title: "Oops...",
                        text: "Invalid Data"
                    });
                });
        }
    },
    setup() {
        onMounted(() => {
            cash('body')
                .removeClass('main')
                .removeClass('error-page')
                .addClass('login')
        })
        return {v$: useVuelidate()}
    }
})
</script>
